export default __webpack_public_path__ + "static/media/logo.4bdbcf83.svg";